import { render, staticRenderFns } from "./ReleasesDataTable.vue?vue&type=template&id=52a4f240&"
import script from "./ReleasesDataTable.vue?vue&type=script&lang=js&"
export * from "./ReleasesDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports